import { render, staticRenderFns } from "./WorkspaceFiles.vue?vue&type=template&id=4f30ddc6&"
import script from "./WorkspaceFiles.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceFiles.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceFiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports